export * from './lib/simple-dialog.module';
